import { Icon } from '@assembly-js/design-system';
import clsx from 'clsx';

export interface SettingsBackLinkProps {
  label: string;
  onClick: () => void;
  className?: string;
}

/** Chevron + parent page name, for settings pages that open from another one. */
export const SettingsBackLink = ({
  label,
  onClick,
  className,
}: SettingsBackLinkProps) => (
  <button
    type="button"
    onClick={onClick}
    className={clsx(
      'box-border inline-flex h-7.5 cursor-pointer items-center gap-1.5 rounded-[4px] border-0 bg-transparent py-0 pr-2.5 pl-1.5 text-[13px] leading-5.5 font-medium text-secondary hover:bg-gray-150 hover:text-black-heading',
      className,
    )}
  >
    <Icon icon="ChevronLeft" className="h-[15px] w-[15px]" />
    {label}
  </button>
);
